module.exports = __webpack_public_path__ + "img/6.08e46626.webp";